import React from 'react';
import type { ProcessListPopoverState } from './useProcessListPopover.ts';

export function ProcessListPopover({
  listPopover,
}: {
  listPopover: ProcessListPopoverState | null;
}): React.ReactElement | null {
  if (!listPopover) return null;
  return (
    <div
      data-process-list-popover
      className="fixed z-30 w-80 max-w-[calc(100vw-2rem)] rounded-lg border border-gray-200 bg-white shadow-xl"
      style={{ top: listPopover.top, left: listPopover.left }}
    >
      <div className="border-b border-gray-100 px-4 py-3">
        <p className="text-sm font-semibold text-gray-900">{listPopover.title}</p>
      </div>
      <ul className="max-h-72 overflow-auto py-2">
        {listPopover.items.map((item, index) => (
          <li
            key={`${item}-${index}`}
            className="border-b border-gray-50 px-4 py-2 text-sm text-gray-800 last:border-b-0"
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
